import { ThemeProvider, BaseStyles } from '@primer/react'
import Home from './Home'
import ColorModeSwitcher from './ColorModeSwitcher'

export default function App() {
    return (
        <ThemeProvider colorMode="auto">
            <BaseStyles>
                <Home />
                <ColorModeSwitcher />
            </BaseStyles>
        </ThemeProvider>
    )
}
